module.exports = __webpack_public_path__ + "static/media/forside.476bd831.jpg";